module.exports = __webpack_public_path__ + "img/noticia1.9962bc9f.jpg";